/**
 * V6.1.B Voice GM (2026-06-02) — per-NPC voice mapping.
 *
 * When the GM dispatcher returns an ask_npc(npc_id, question) action,
 * the NPC's reply text is enqueued with this voice instead of the
 * persistent narrator voice — so Dr. No actually sounds menacing,
 * Moneypenny actually sounds Moneypenny-ish, etc.
 *
 * Voice ids verified against the live Kokoro catalog on dallas
 * (/api/voice/voices?engine=kokoro, 2026-06-02, 67 voices). The map
 * covers all canonical NPCs that appear in dr_no_adventure.scenario or
 * the hardcoded KEY_NPCS baseline of scenario_context.py, plus a few
 * frequently-referenced franchise NPCs.
 *
 * Unknown NPC ids fall through to the narrator voice — no silent ride
 * on a wrong character voice.
 */

export const NPC_VOICE_MAP: Readonly<Record<string, string>> = {
  // MI6 baseline (hardcoded KEY_NPCS in scenario_context.py)
  m_admiral_sir_miles_messervy: 'bm_lewis',
  miss_moneypenny: 'bf_emma',
  major_geoffrey_boothroyd: 'bm_daniel',
  chief_of_staff_william_tanner: 'bm_fable',
  james_bond: 'bm_george',

  // Dr. No scenario.key_npcs
  pamela_holck: 'bf_lily',
  ahmal_ben_gazi: 'am_onyx',
  phyllis_marlowe: 'bf_alice',
  dr_julius_no_alias_reveal: 'am_onyx',

  // allies_enemies enrichment (substring-matched in scenario_context)
  dr_julius_no: 'am_onyx',

  // Allies cross-referenced
  honey_ryder: 'af_heart',
  quarrel: 'am_adam',
  felix_leiter: 'am_eric',

  // Franchise enemies (may appear in future scenarios)
  sir_hugo_drax: 'bm_fable',
  auric_goldfinger: 'am_onyx',
  jaws: 'am_fenrir',
  rosa_klebb: 'bf_alice',
  donovan_red_grant: 'am_eric',
  pussy_galore: 'af_heart',
  kananga: 'am_onyx',
};

/**
 * Resolve the Kokoro voice id for an NPC, or undefined when there's no
 * mapping. The caller decides the fallback — typically the narrator
 * voice — so this hook stays UI-agnostic.
 */
export function voiceForNpc(npcId: string | undefined | null): string | undefined {
  if (typeof npcId !== 'string' || npcId.length === 0) {
    return undefined;
  }
  return NPC_VOICE_MAP[npcId];
}
